<script>
  import { configStore } from "../../../stores/config.store";

  import SearchSelect from "../../../components/SearchSelect/SearchSelect.svelte";
  import Icon from "../../../components/Icon/Icon.svelte";
  import { get as get_store } from "svelte/store";
  import get from "get-value";
  import { vratZoznamSelectu } from "../../../api/selects";
  import { otvorPopup } from "../../../helpers/popup";
  import Diacritics from "diacritic";
  import { showHideSelect, onDocumentClick } from "./header.func";
  import { zobrazDataNaMape } from "../../../helpers/map";

  const selecty = get(get_store(configStore), "selecty", []);
</script>

<div class="header__body">
  {#each selecty as select, i}
    <!-- Input select start -->
    <div
      class="select input__group"
      style="z-index: {15 - i};"
      on:click={showHideSelect}
    >
      <div class="select__header color__bg--{select.kod_farby}">
        <div class="select__label">
          <div class="select__label-wrapper">
            <Icon kod={select.kod_ikonky} />
          </div>
          <span class="select__text">{select.nazov}</span>
        </div>

        <Icon kod="003" />
      </div>
      <div class="select__body">
        <SearchSelect
          searchFunction={vratZoznamSelectu}
          searchFunctionOnce="true"
          labelFieldName="nazov"
          inputClassName="select__search"
          dropdownClassName="select__list"
          placeholder="Hľadať"
          {select}
          keywordsCleanFunction={(keyword) => Diacritics.clean(keyword)}
          textCleanFunction={(keyword) => Diacritics.clean(keyword)}
          beforeChange={async (o, n) => {
            await zobrazDataNaMape(n);
            otvorPopup(n.gistyp || n.typ, n.id, n.nazov, n.typ);
          }}
          runOnInit="true"
        />
      </div>
    </div>
    <!-- Input select end -->
  {/each}
</div>

<svelte:window on:click={onDocumentClick} />

<style>
  .header__body {
    width: 40%;
  }
</style>
